import { Environment } from 'src/app/models/projects.model';

export const environment: Environment = {
  production: false,
  docInsightsWidgetKey: 'xd9mwE.bqSsfdooOwBhGfVsJHNJiMnntRIiW743w0V7T03wndjhtnD8yhpEBIa',
  configSecretKey: 'UY1QmFzL6y?Bk!?H',
};
